import { Component } from '@angular/core';

@Component({
  selector: 'app-histo26',
  templateUrl: './histo26.component.html',
  styleUrl: './histo26.component.css'
})
export class Histo26Component {

}
